<template>
  <div
    :class="`
      standard-data-field
      t-rounded
      ${color?color:''}
      ${flat?'':'t-shadow'}
      `"
    :style="`
      width: ${width?width:''};
      height: ${height?height:''};
      line-height: ${line_height?line_height:''};
      color: ${text_color?text_color:'black'};
      ${text_color == 'primary'?'color: var(--v-primary-base);':''};
      ${flat?'':'margin-bottom: 3px'}
      `"
    >
    <slot name="prepend-slot"/>
    <div style="position: relative; height: 20px">
    <v-icon
      class="standard-data-field-icon ml-1 mr-1"
      v-if="icon"
      :color="text_color?text_color:'black'"
      :size="22"
      >
      {{icon}}
    </v-icon>
    <!-- @click="$emit('clickPrependIcon')" -->
    <div
      v-if="icon && icon_actual"
      class="standard-data-field-icon-actual-value green"
      />
    </div>
    <v-img
      v-if="image"
      :src="image"
      class="standard-data-image-preview"
      height="34px"
      width="47px"
      contain
      @click="$emit('clickImage')"
      >
      <template v-slot:placeholder>
      <v-row
        class="fill-height ma-0"
        align="center"
        justify="center"
      >
        <v-progress-circular
          indeterminate
          color="grey lighten-5"
        ></v-progress-circular>
      </v-row>
      </template>
    </v-img>
    <v-img
      v-if="file_src && file_type == 'image'"
      :src="file_src"
      class="standard-data-image-preview"
      height="34px"
      width="47px"
      contain
      @click="$emit('clickImage')"
      >
      <template v-slot:placeholder>
      <v-row
        class="fill-height ma-0"
        align="center"
        justify="center"
      >
        <v-progress-circular
          indeterminate
          color="grey lighten-5"
        ></v-progress-circular>
      </v-row>
      </template>
    </v-img>
    <div
    v-if="file_src && file_type == 'pdf'"
    style="cursor: pointer"
    v-on:click="$emit('clickImage')"
    >
      <pdf
        class="file-box"
        :src="file_src"/>
    </div>
    <div
      v-if="file_src && file_type == 'other'"
      style="cursor: pointer"
      v-on:click="$emit('clickImage')"
      >
      <v-icon
        :size="30">
        insert_drive_file
      </v-icon>
      {{file_extension}}
    </div>
    <div class="standard-data-field-data">
    <div
      class="standard-data-field-header"
      v-if="header">
      {{header}}
    </div>
    <input
      v-if="type === 'number'"
      ref="standard-data-field-input"
      class="standard-data-field-input"
      :style="`
        ${readonly?'cursor: default;':''}
        ${text_align?`text-align: ${text_align};`:''}
        `"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :type="type"
      :min="0"
      :dir="rtl?'rtl':'ltr'"
      @input="resizeHeight(), $emit('inputValue', $event.target.value)"
      @change="$emit('changeValue', $event.target.value)"
      >
      <input
        v-else-if="one_liner"
        ref="standard-data-field-input"
        class="standard-data-field-input"
        :style="`
          cursor: ${readonly?'default;':''};
          ${text_center?'text-align: center;':''}
          `"
        :readonly="readonly"
        :value="value"
        :placeholder="placeholder"
        :type="type"
        :min="0"
        :dir="rtl?'rtl':'ltr'"
        :maxlength="maxlength"
        @input="resizeHeight(), $emit('inputValue', $event.target.value)"
        @change="$emit('changeValue', $event.target.value)"
        />
    <textarea
      v-else
      ref="standard-data-field-input"
      class="standard-data-field-input"
      :style="`
        cursor: ${readonly?'default;':''};
        resize: ${resizable?'vertical;':'none;'}
        ${text_center?'text-align: center;':''}
        text-decoration:  ${crossed_out?'line-through;':'none;'}
        color: ${text_color?text_color:'var(--primary)'};
        ${text_color == 'primary'?'color: var(--v-primary-base);':''};
        `"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :type="type"
      :min="0"
      :dir="rtl?'rtl':'ltr'"
      :maxlength="maxlength"
      @input="resizeHeight(), $emit('inputValue', $event.target.value)"
      @change="$emit('changeValue', $event.target.value)"
      />
    </div>
    <v-icon
      class="ml-1 mr-1"
      v-if="append_icon"
      :color="text_color?text_color:'black'"
      @click="$emit('clickAppendIcon')"
      :size="23"
      >
      {{append_icon}}
    </v-icon>
    <v-icon
      class="ml-1 mr-1"
      v-if="append_icon_2"
      :color="text_color?text_color:'black'"
      @click="$emit('clickAppendIcon2')"
      :size="23"
      >
      {{append_icon_2}}
    </v-icon>
    <div class="standard-data-field-append-slot">
      <slot name="append-slot"/>
    </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
  export default {
    components: {
      pdf
    },
    props: [
      'text_color',
      'text_center',
      'color',
      'width',
      'height',
      'line_height',
      'icon',
      'icon_actual',
      'append_icon',
      'value',
      'header',
      'readonly',
      'flat',
      'placeholder',
      'type',
      'min',
      'resizable',
      'maxlength',
      'text_align',
      'rtl',
      'one_liner',
      'file_src',
      'file_type',
      'file_extension',
      'crossed_out',
      'image',
      'append_icon_2'
    ],
    mounted() {
      let  el = this.$refs['standard-data-field-input']
      el.style.height = "25px";
      if ([
        'TaktPlanAddWorkPackageDetails',
        'ProjectMilestonesDetails',
        'ProjectMilestonesEdit',
        'ProjectMilestonesAdd',
        'TrainMilestonesDetails',
        'TrainMilestonesEdit',
        'TrainMilestonesAdd',
        ].includes(this.$route.name)) {
        setTimeout(function () {
          el.style.height = (el.scrollHeight)+"px";
        }, 600);
      } else {
        el.style.height = (el.scrollHeight)+"px";
      }
    },
    updated() {
      let  el = this.$refs['standard-data-field-input']
      el.style.height = "25px";
      el.style.height = (el.scrollHeight)+"px";
    },
    methods: {
      resizeHeight() {
        let  el = this.$refs['standard-data-field-input']
        el.style.height = "25px";
        el.style.height = (el.scrollHeight)+"px";
      }
    }
  }
</script>
<style>
  .standard-data-field {
    display: flex;
    color: black;
    line-height: 25px;
    flex-shrink: 0;
    /* height: 25px; */
    /* padding: 2px; */
  }
  .standard-data-image-preview {
    margin: 2px;
    cursor: pointer;
  }
  
  .standard-data-field-header {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: -2px;
    color: var(--v-primary-base);
  }
  
  .standard-data-field-data {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .standard-data-field-input {
    width: 100%;
    min-height: 25px;
    resize: none;
    overflow: hidden;
    size: 10;
  }

  .standard-data-field-input:focus {
    outline: none;
  }

  .standard-data-field-input::placeholder {
    font-style: italic;
    color: var(--v-secondary-base);
  }

  .standard-data-field-icon-actual-value {
    position: absolute;
    height: 5px;
    width: 5px;
    right: 3px;
    top: 1px;
    border-radius: 5px;
    z-index: 4;
  }

  .standard-data-field-append-slot {
    display: flex;
    align-items: center;
  }
  .file-box {
    /* height: 34px; */
    width: 47px;
    display: inline-block;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
